import { render, staticRenderFns } from "./Positions.vue?vue&type=template&id=78fe16d0&scoped=true"
import script from "./Positions.js?vue&type=script&lang=js&external"
export * from "./Positions.js?vue&type=script&lang=js&external"
import style0 from "./Positions.scss?vue&type=style&index=0&id=78fe16d0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe16d0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotPositionsSearch: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/PositionsSearch/PositionsSearch.vue').default,HotHero: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Organisms/Hero/Hero.vue').default,HotSelectAccordion: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/SelectAccordion/SelectAccordion.vue').default,HotPositionsListItems: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/PositionsListItems/PositionsListItems.vue').default})
